<template>
  <div class="calendar-modules-container">

    <div v-if="modalOpened" class="madalbackground" @click="closeModals"></div>

    <div class="container">
      <transition tag="div" name="fadeDown">
        <div class="mandatory-modal d-flex flex-column mx-auto p-2" v-if="mapModal">
          <l-map style="height: 180px" :zoom="zoom" :center="center" @click="openMap(latlon)">
            <l-tile-layer :attribution="attribution" :url="url"></l-tile-layer>
            <l-marker :lat-lng="latlon" ></l-marker>
          </l-map>
        </div>
      </transition>
    </div>


    <div class="calendar-modules">
      <div class="mainbox-calendar">
          <img class="spiralimage" src="~@/assets/img/calendar/spiral.png">
          <div class="main-slider-container">

            <div class="topwallimage">

              <div class="event-selected d-flex flex-column justify-content-center align-items-center text-center" v-if="eventSelected">
                  <div class="inner-event d-flex flex-column justify-content-center align-items-center text-center">
                    <h5 class="event-title">{{eventSelected.title}}</h5>
                    <div class="event-des">{{eventSelected.des}}</div>
                    <div class="event-place">{{eventSelected.address}}</div>
                    <div class="event-map" @click="openMapModal(eventSelected.lat,eventSelected.lon)">نمایش روی نقشه</div>
                  </div>
              </div>

             <!-- <div v-swiper:mySwiper="options">
                <div class="swiper-wrapper">
                  <router-link tag="div"
                               v-for="item in gallery"
                               :to='`/restaurant/${item.id}`'
                               :key="item.id"
                               class="img-wrapper swiper-slide">
                    <img :src="`https://kishoto.ir/dtr/approid/img/${item.image}`" />

                  </router-link>

                </div>

              </div>
              <div class="swiper-pagination"></div>-->
            </div>

            <p class="calendar-title">نمایش برنامه ها و پلن های فستیوال کیش</p>

          </div>


          <div class="event-calendar-container">
            <persian-calendar :events-list="events" :disable-past-days="true" :hide-event-times="true" @on-event-click="eventClick"  @on-day-click="daySelect"></persian-calendar>
          </div>
        <div class="calendar-guidance d-flex flex-row justify-content-start text-right pb-4">
              <div class="guidance-column d-flex flex-column w-50">
                  <div class="calendar-item"><span class="green"></span>کنسرت</div>
                  <div class="calendar-item"><span class="purple"></span>جنگ</div>
                  <div class="calendar-item"><span class="orange"></span>استعداد یابی</div>
              </div>
              <div class="guidance-column d-flex flex-column">
                <div class="calendar-item"><span class="red"></span>افتتاحیه فستیوال</div>
                <div class="calendar-item"><span class="blue"></span>فینال فستیوال</div>
                <div class="calendar-item"><span class="black"></span>رویداد های جزیره</div>
              </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  data() {
    return {
      events:[
        {id:1, startDateTime:this.$moment('1399/05/07 19:30', 'jYYYY/jMM/jDD HH:mm'), endDateTime:this.$moment('1399/05/09 07:15', 'jYYYY/jMM/jDD HH:mm'), title:'رویداد شماره ۱', color:'#2a79b8', classes: []},
        {id:2, startDateTime:this.$moment('1399/05/13 10:30', 'jYYYY/jMM/jDD HH:mm'), endDateTime:this.$moment('1399/05/13 15:00', 'jYYYY/jMM/jDD HH:mm'), title:'رویداد شماره ۲', color:'#a71749', classes: []},
        {id:7, startDateTime:this.$moment('1399/05/13 10:30', 'jYYYY/jMM/jDD HH:mm'), endDateTime:this.$moment('1399/05/13 11:30', 'jYYYY/jMM/jDD HH:mm'), title:'گفتگوی اسکایپی با مدیر شرکت آرمان', color:'#a71749', classes: []},
        {id:4, startDateTime:this.$moment('1399/05/09 10:30', 'jYYYY/jMM/jDD HH:mm'), endDateTime:this.$moment('1399/05/13 14:00', 'jYYYY/jMM/jDD HH:mm'), title:'رویداد شماره ۳', color:'#34147e', classes: []},
        {id:5, startDateTime:this.$moment('1399/05/06 10:30', 'jYYYY/jMM/jDD HH:mm'), endDateTime:this.$moment('1399/05/08 18:35', 'jYYYY/jMM/jDD HH:mm'), title:'رویداد شماره ۴', color:'#34147e', classes: []},
        {id:3, startDateTime:this.$moment('1399/05/10', 'jYYYY/jMM/jDD'), endDateTime:this.$moment('1399/05/25', 'jYYYY/jMM/jDD'), title:'گفتگوی اسکایپی با مدیر شرکت آرمان', color:'#cb09cb', classes: []}
      ],
      loading:false,
      eventSelected:null,
      modalOpened:false,
      mapModal:false,

      url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic2FsaXM3NyIsImEiOiJja3BpZ2t0NGMydmE0MnJsbGVyaHl1N2ljIn0.5-RgHI1eRz0jXhqSTFDYnA',
      zoom: 100,
      attribution: '<a href="https://kishoto.ir">کیشوتو</a>',
      center: [47.313220, -1.319482],
      latlon: [47.313220, -1.319482],
    };
  },
  created() {
    this.getEvents();
  },
  components:{
    LMap,
    LTileLayer,
    LMarker,
  },
  computed: {

  },
  methods: {
    async getEvents(){
      this.loading = true;
      const response = await this.$ApiServiceLayer.post("calendar");

      if (response.status_code === 200) {

        this.events = [];

        response.list.map((value,key)=>{
          this.events.push({
            id:value.id,
            startDateTime : this.$moment(value.date,'YYYY-MM-DD'),
            endDateTime : this.$moment(value.date,'YYYY-MM-DD'),
            title:value.title,
            color:'#'+value.color_code,
            lat:value.lat,
            lon:value.lon,
            des:value.des,
            address:value.address
          });
        });

        //this.events = response.list;
        this.loading = false;
        console.log(this.events);
      } else {
        this.$toast.open({
          message: 'مشکلی در دریافت اطلاعات پیش آمده است',
          type: 'error',
        });
        this.loading = false;
      }
    },

    eventClick(event){
      console.log(event);
      this.eventSelected = event;
    },
    daySelect(object){
      console.log(object);
      this.eventSelected = null;
    },
    closeModals() {
      this.modalOpened = false;
      this.mapModal = false;
    },
    openMapModal(lat,lon){
      this.mapModal = true;
      this.modalOpened = true;
      this.latlon = [lat,lon];
      this.center = [lat,lon];
    },
    openMap(latlon){
      window.open(`https://www.google.com/maps/search/?api=1&query=${latlon[0]},${latlon[1]}`,'_blank');
    }
  },
};
</script>

<style lang="scss" scoped>
.calendar-modules-container{
  width: 100%;
  height: 100%;
  .calendar-modules {
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/img/bg/profile_history.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: fixed;
    top: 0;
    left: 0;
    overflow-y: auto;
    .mainbox-calendar{
      width: 89%;
      height: auto;
      background: #ffffff;
      margin: 0 auto;
      margin-top: 45px;
      border-radius: 16px;
      .spiralimage{
        width: 100%;
        position: relative;
        bottom: 17px;
      }
      .main-slider-container{
        width: 100%;
        height: auto;
        .topwallimage{
          width: 93%;
          height: 218px;
          background-image: url("~@/assets/img/calendar/kishwall.jpg");
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 10px;
          margin: 0 auto;

          .event-selected{
            height: 100%;
            padding: 6px;
            background: #ffffffba;
            .inner-event{
              width: 100%;
              height: 100%;
              border:2px dashed #9e9e9e;
              .event-map{
                border-bottom: 1px solid blue;
                color:#304fee
              }
            }
          }

        }
        .calendar-title{
          text-align: center;
          padding-bottom: 11px;
          padding-top: 14px;
          font-family: 'sansb';
          border-bottom: 3px dashed #9e9e9e;
        }
      }
      .calendar-guidance{
        direction: rtl;
        .guidance-column{
          span{
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-left: 6px;
            display: inline-block;
            margin-right: 7px;
          }
          .green{
            background: #00c853;
          }
          .purple{
            background: #9c27b0;
          }
          .orange{
            background: #ff6d00;
          }
          .red{
            background: #f44336;
          }
          .blue{
            background: #536dfe;
          }
          .black{
            background: #37474f;
          }
        }
      }
      .event-calendar-container{
        margin-bottom: 27px;
        padding: 15px;
      }
    }
  }
  .madalbackground{
    width: 100%;
    height: 100%;
    background: #0000006e;
    position: fixed;
    z-index: 2;
  }

  .mandatory-modal {
    position: fixed;
    height: 500px;
    width: 97%;
    background-color: #fff;
    border-radius: 10px;
    padding: 0px;
    direction: rtl;
    z-index: 2;
    overflow-y:scroll;
    overflow-x:hidden;
    border: 1px dashed #80808033;
    position: fixed;
    height: 456px;
    width: 97%;
    background-color: #fff;
    border-radius: 10px;
    padding: 0px;
    direction: rtl;
    z-index: 2;
    overflow-y: scroll;
    overflow-x: hidden;
    border: 1px dashed #80808033;
    bottom: 51%;
    left: 0;
    right: 0;
    top: 29%;

    .vue2leaflet-map{
      height: 100% !important;
    }
  }

}
</style>
